import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper
} from '@mui/material';
import { History } from '@mui/icons-material';
import { API_BASE_URL, PAGO_LICENCIA_LISTAR } from '../services/apiConfig';
import Cargando from './utils/Cargando.jsx';

function HistorialPagos() {
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPagos();
  }, []);

  const fetchPagos = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const response = await axios.get(API_BASE_URL + PAGO_LICENCIA_LISTAR, { headers });
      if (response.data.success) {
        setPagos(response.data.data || []);
      }
    } catch (error) {
      console.error('Error al cargar historial de pagos:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Cargando inline size={24} />
    );
  }

  if (pagos.length === 0) {
    return (
      <Box sx={{ p: 1.5, bgcolor: 'grey.100', borderRadius: 1 }}>
        <Typography variant="body2" color="text.secondary">
          No hay pagos registrados.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <History fontSize="small" color="primary" />
        <Typography variant="subtitle2">Últimos pagos</Typography>
      </Box>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>Fecha de pago</strong></TableCell>
              <TableCell><strong>Monto</strong></TableCell>
              <TableCell><strong>Registrado</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pagos.map((pago) => (
              <TableRow key={pago.id}>
                <TableCell>{new Date(pago.fecha_pago + 'T12:00:00').toLocaleDateString('es-AR')}</TableCell>
                <TableCell>${parseFloat(pago.monto).toFixed(2)}</TableCell>
                <TableCell>{new Date(pago.created_at).toLocaleString('es-AR')}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default HistorialPagos;
